import { CodeTextInputComponent } from './kymw02/code-text-input/code-text-input.component';
import { FileUploadService } from './kymw02/file-upload/file-upload.service';
import { CheckNgWordsService } from './kymw02/check-ng-words/api-services/check-ng-words.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { PlessSharedModule } from '../shared/pless-shared.module';

import { KYMW00Model } from './kymw00/kymw00.model';
import { PlessInputTextSubDirective } from './kymw00/pless-input-text-sub.directive';
import { PlessDialogServiceSub } from './kymw00/pless-dialog-service-sub';
import { PlessDialogMultiMessageServiceSub } from './kymw00/pless-dialog-multi-message-service-sub';

import { DnaInfoComboBoxComponent } from './kymw02/combo-box/dna-info-combo-box/dna-info-combo-box.component';
import { PromotionInfoComboBoxComponent } from './kymw02/combo-box/promotion-info-combo-box/promotion-info-combo-box.component';
import { ClassCodeComboBoxComponent } from './kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';
import { CodeComboBoxComponent } from './kymw02/combo-box/code-combo-box/code-combo-box.component';
import { ReserveCodeComboBoxComponent } from './kymw02/combo-box/reserve-code-combo-box/reserve-code-combo-box.component';
import { LargeClassCodeComboBoxComponent } from './kymw02/combo-box/large-class-code-combo-box/large-class-code-combo-box.component';
import { MiddleClassCodeComboBoxComponent } from './kymw02/combo-box/middle-class-code-combo-box/middle-class-code-combo-box.component';
import { SmallClassCodeComboBoxComponent } from './kymw02/combo-box/small-class-code-combo-box/small-class-code-combo-box.component';
import { NotNullTextAreaComponent } from './kymw02/not-null-text-area/not-null-text-area.component';
import { StudioMasterComboBoxComponent } from './kymw02/combo-box/studio-master-combo-box/studio-master-combo-box.component';
import { PeriodSeqComboBoxComponent } from './kymw02/combo-box/period-seq-combo-box/period-seq-combo-box.component';
import { MediumTypeComboBoxComponent } from './kymw02/combo-box/medium-type-combo-box/medium-type-combo-box.component';
import { GroupingCodeComboBoxComponent } from './kymw02/combo-box/grouping-code-combo-box/grouping-code-combo-box.component';
import { VMediumTypeComboBoxComponent } from './kymw02/combo-box/vmedium-type-combo-box/vmedium-type-combo-box.component';
import {
  VMediumDutiesFormTypeComboBoxComponent
} from './kymw02/combo-box/vmedium-duties-form-type-combo-box/vmedium-duties-form-type-combo-box.component';
import { PageComboBoxComponent } from './kymw02/combo-box/page-combo-box/page-combo-box.component';
import {
  CwsPlanCategoryCodeComboBoxComponent
} from './kymw02/combo-box/cws-plan-category-code-combo-box/cws-plan-category-code-combo-box.component';
import {
  OrderNumQuotaCodeComboBoxComponent
} from './kymw02/combo-box/order-num-quota-code-combo-box/order-num-quota-code-combo-box.component';
import { PromotionCodeComboBoxComponent } from './kymw02/combo-box/promotion-code-combo-box/promotion-code-combo-box.component';
import { ConvDivComboBoxComponent } from './kymw02/combo-box/conv-div-combo-box/conv-div-combo-box.component';
import { SellAreaCodeComboBoxComponent } from './kymw02/combo-box/sell-area-code-combo-box/sell-area-code-combo-box.component';
import { AssortTempDivComboBoxComponent } from './kymw02/combo-box/assort-temp-div-combo-box/assort-temp-div-combo-box.component';
import { FeatureCodeComboBoxComponent } from './kymw02/combo-box/feature-code-combo-box/feature-code-combo-box.component';
import { TagComboBoxComponent } from './kymw02/combo-box/tag-combo-box/tag-combo-box.component';
import { VersatileComboBoxComponent } from './kymw02/combo-box/versatile-combo-box/versatile-combo-box.component';

import { CommaFormatComponent } from './kymw02/comma-format/comma-format.component';
import { MarkCodeComponent } from './kymw02/mark-code/mark-code.component';

import { IconCodeTextInputComponent } from './kymw02/text-input/icon-code-text-input/icon-code-text-input.component';
import { MarkCodeTextInputComponent } from './kymw02/text-input/mark-code-text-input/mark-code-text-input.component';

import { DispContentsTextComponent } from './kymw02/text-input/disp-contents-text/disp-contents-text.component';
import { SupplyPriceStandardTextComponent } from './kymw02/text-input/supply-price-standard-text/supply-price-standard-text.component';

import { CodeCheckBoxListComponent } from './kymw02/list/code-check-box-list/code-check-box-list.component';
import { CodeListComponent } from './kymw02/list/code-list/code-list.component';
import { DnaInfoCheckBoxListComponent } from './kymw02/list/dna-info-check-box-list/dna-info-check-box-list.component';
import { ClassificationsListComponent } from './kymw02/list/classifications-list/classifications-list.component';

import { DnaInfoComboBoxService } from './kymw02/combo-box/dna-info-combo-box/api-services/dna-info-combo-box.service';
import { GetCodeListService } from './kymw02/combo-box/code-combo-box/api-services/get-code-list.service';
import { GetReserveCodeListService } from './kymw02/combo-box/reserve-code-combo-box/api-services/get-reserve-code-list.service';
import { GetClassListService } from './kymw02/combo-box/class-code-combo-box/api-services/get-class-list.service';
import { GetLargeClassListService } from './kymw02/combo-box/large-class-code-combo-box/api-services/get-large-class-list.service';
import { GetMiddleClassListService } from './kymw02/combo-box/middle-class-code-combo-box/api-services/get-middle-class-list.service';
import { GetSmallClassListService } from './kymw02/combo-box/small-class-code-combo-box/api-services/get-small-class-list.service';
import { GetPromotionInfoListService } from './kymw02/combo-box/promotion-info-combo-box/api-services/get-promotion-info-list.service';
import { GetStudioMasterListService } from './kymw02/combo-box/studio-master-combo-box/api-services/get-studio-master-list.service';
import { GetPeriodSeqListService } from './kymw02/combo-box/period-seq-combo-box/api-services/get-period-seq-list.service';
import { GetGroupingCodeListService } from './kymw02/combo-box/grouping-code-combo-box/api-services/get-grouping-code-list.service';
import {
  GetCwsPlanCategoryListService
} from './kymw02/combo-box/cws-plan-category-code-combo-box/api-services/get-cws-plan-category-list.service';
import { GetSellAreaCodeListService } from './kymw02/combo-box/sell-area-code-combo-box/api-services/get-sell-area-code-list.service';


import { PanelComponent } from './kymw02/panel/panel.component';
import { CheckboxLabelComponent } from './kymw02/checkbox-label/checkbox-label.component';
import { RadioLabelComponent } from './kymw02/radio-label/radio-label.component';
import { CoopCodeComboBoxComponent } from './kymw02/combo-box/coop-code-combo-box/coop-code-combo-box.component';
import { GetCoopListService } from './kymw02/combo-box/coop-code-combo-box/api-services/get-coop-list.service';
import { OrderCodeTextInputComponent } from './kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { OrderTextWithCatalogComponent } from './kymw02/text-input/order-text-with-catalog/order-text-with-catalog.component';
import { CatalogTextWithOrderComponent } from './kymw02/text-input/catalog-text-with-order/catalog-text-with-order.component';
import { GetOrderListService } from './kymw02/text-input/order-code-text-input/api-services/get-order-list.service';
import { GetMediumListService } from './kymw02/combo-box/medium-type-combo-box/api-services/get-medium-list.service';
import { GetVMediumListService } from './kymw02/combo-box/vmedium-type-combo-box/api-services/get-vmedium-list.service';
import {
  GetVMediumDutiesListService
} from './kymw02/combo-box/vmedium-duties-form-type-combo-box/api-services/get-vmedium-duties-list.service';
import { GetPageListService } from './kymw02/combo-box/page-combo-box/api-services/get-page-list.service';
import {
  GetOrderNumQuotaListService
} from './kymw02/combo-box/order-num-quota-code-combo-box/api-services/get-order-num-quota-list.service';
import { GetMarkListService } from './kymw02/text-input/mark-code-text-input/api-services/get-mark-list.service';
import { GetIconListService } from './kymw02/text-input/icon-code-text-input/api-services/get-icon-list.service';
import { GetConvDivListService } from './kymw02/combo-box/conv-div-combo-box/api-services/get-conv-div-list.service';
import { GetPromotionCodeListService } from './kymw02/combo-box/promotion-code-combo-box/app-services/get-promotion-code-list.service';
import { NotNullTextInputComponent } from './kymw02/not-null-text-input/not-null-text-input.component';

import { CatalogProgressTextInputComponent } from './kymw02/text-input/catalog-progress-text-input/catalog-progress-text-input.component';
import {
  GetCatalogProgressListService
} from './kymw02/text-input/catalog-progress-text-input/api-services/get-catalog-progress-list.service';
import { GetClassificationsListService } from './kymw02/list/classifications-list/api-services/get-classifications-list.service';
import { GetMessagesService } from '../shared/get-messages.service';
import { GetMultiMessagesService } from '../shared/get-multi-messages.service';
import { PlessTitleWindowSubDirective } from './kymw00/pless-title-window-sub.directive';
import { PlessAlertSubComponent } from './kymw00/pless-alert/pless-alert-sub.component';
import { FileDownloadMultiService } from './kymw02/file-download-confirm/file-download-multi.service';
import { PagerComponent } from './kymw02/pager/pager.component';
import { CustomPagerComponent } from './kymw02/custom-pager/custom-pager.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TextInputComponent } from './kymw02/text-input/text-input/text-input.component';
import { TextAreaComponent } from './kymw02/text-input/text-area/text-area.component';
import { ClipboardCopyIconComponent } from './kymw02/clipboard-copy-icon/clipboard-copy-icon.component';
import { GetFeatureCodeListService } from './kymw02/combo-box/feature-code-combo-box/api-services/get-feature-code-list.service';
import {
  GetGoodsEcCategoryListService
} from './kymw02/combo-box/goods-ec-category-code-combo-box/api-services/get-goods-ec-category-list.service';
import {
  GoodsEcCategoryCodeComboBoxComponent
} from './kymw02/combo-box/goods-ec-category-code-combo-box/goods-ec-category-code-combo-box.component';
import { KYMW68GetConvDivListService } from './kymw68/combo-box/conv-div-combo-box/api-services/get-conv-div-list.service';
import { KYMW68ConvDivComboBoxComponent } from './kymw68/combo-box/conv-div-combo-box/conv-div-combo-box.component';
import { KYMW68GetFeatureCodeListService } from './kymw68/combo-box/feature-code-combo-box/api-services/get-feature-code-list.service';
import { Kymw68FeatureCodeComboBoxComponent } from './kymw68/combo-box/feature-code-combo-box/feature-code-combo-box.component';
import { KYMW68GetTagListService } from './kymw68/combo-box/tag-combo-box/api-services/get-tag-list.service';
import { Kymw68TagComboBoxComponent } from './kymw68/combo-box/tag-combo-box/tag-combo-box.component';
import { GetMediumListPlanGoodsFlagService } from './kymw02/combo-box/plan-medium-type-combo-box/api-services/get-medium-list-plan-goods-flag.service';
import { PlanMediumTypeComboBoxComponent } from './kymw02/combo-box/plan-medium-type-combo-box/plan-medium-type-combo-box.component';
import { KomaMediumTypeComboBoxComponent } from './kymw02/combo-box/koma-medium-type-combo-box/koma-medium-type-combo-box.component';
import { GetMediumListKomaFlagService } from './kymw02/combo-box/koma-medium-type-combo-box/api-services/get-medium-list-koma-flag.service';
import { PlessInputTextCoopDeliDirective } from './kymw00/pless-input-text-coop-deli.directive';
import { TextInputCoopDeliComponent } from './kymw02/text-input/text-input-coop-deli/text-input-coop-deli.component';
import { NotNullTextInputCoopDeliComponent } from './kymw02/not-null-text-input-coop-deli/not-null-text-input-coop-deli.component';
import { GetUserColumnWidthSettingsService } from './kymw02/api-services/get-user-column-width-settings.service';
import { RegistUserColumnWidthSettingsService } from './kymw02/api-services/regist-user-column-width-settings.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WjNavModule,
    WjGridModule,
    WjInputModule,
    PlessSharedModule,
    FontAwesomeModule,
    NgbTooltipModule
  ],
  exports: [
    PlessAlertSubComponent,
    DnaInfoComboBoxComponent,
    PromotionInfoComboBoxComponent,
    ClassCodeComboBoxComponent,
    CodeComboBoxComponent,
    ReserveCodeComboBoxComponent,
    LargeClassCodeComboBoxComponent,
    MiddleClassCodeComboBoxComponent,
    SmallClassCodeComboBoxComponent,
    NotNullTextAreaComponent,
    NotNullTextInputComponent,
    CodeCheckBoxListComponent,
    CodeListComponent,
    PanelComponent,
    CheckboxLabelComponent,
    RadioLabelComponent,
    PlessInputTextSubDirective,
    CoopCodeComboBoxComponent,
    StudioMasterComboBoxComponent,
    PeriodSeqComboBoxComponent,
    OrderCodeTextInputComponent,
    OrderTextWithCatalogComponent,
    CatalogTextWithOrderComponent,
    MediumTypeComboBoxComponent,
    GroupingCodeComboBoxComponent,
    VMediumTypeComboBoxComponent,
    VMediumDutiesFormTypeComboBoxComponent,
    PageComboBoxComponent,
    CwsPlanCategoryCodeComboBoxComponent,
    OrderNumQuotaCodeComboBoxComponent,
    DnaInfoCheckBoxListComponent,
    PromotionCodeComboBoxComponent,
    ConvDivComboBoxComponent,
    CatalogProgressTextInputComponent,
    IconCodeTextInputComponent,
    MarkCodeTextInputComponent,
    CommaFormatComponent,
    MarkCodeComponent,
    CodeTextInputComponent,
    DispContentsTextComponent,
    SupplyPriceStandardTextComponent,
    SellAreaCodeComboBoxComponent,
    AssortTempDivComboBoxComponent,
    FeatureCodeComboBoxComponent,
    TagComboBoxComponent,
    VersatileComboBoxComponent,
    ClassificationsListComponent,
    PlessTitleWindowSubDirective,
    PagerComponent,
    CustomPagerComponent,
    TextInputComponent,
    TextAreaComponent,
    ClipboardCopyIconComponent,
    GoodsEcCategoryCodeComboBoxComponent,
    KYMW68ConvDivComboBoxComponent,
    Kymw68FeatureCodeComboBoxComponent,
    Kymw68TagComboBoxComponent,
    PlanMediumTypeComboBoxComponent,
    KomaMediumTypeComboBoxComponent,
    PlessInputTextCoopDeliDirective,
    TextInputCoopDeliComponent,
    NotNullTextInputCoopDeliComponent,
  ],
  declarations: [
    PlessAlertSubComponent,
    DnaInfoComboBoxComponent,
    PromotionInfoComboBoxComponent,
    ClassCodeComboBoxComponent,
    CodeComboBoxComponent,
    ReserveCodeComboBoxComponent,
    LargeClassCodeComboBoxComponent,
    MiddleClassCodeComboBoxComponent,
    SmallClassCodeComboBoxComponent,
    NotNullTextAreaComponent,
    NotNullTextInputComponent,
    CodeCheckBoxListComponent,
    CodeListComponent,
    PanelComponent,
    CheckboxLabelComponent,
    RadioLabelComponent,
    PlessInputTextSubDirective,
    CoopCodeComboBoxComponent,
    StudioMasterComboBoxComponent,
    PeriodSeqComboBoxComponent,
    OrderCodeTextInputComponent,
    OrderTextWithCatalogComponent,
    CatalogTextWithOrderComponent,
    MediumTypeComboBoxComponent,
    VMediumTypeComboBoxComponent,
    VMediumDutiesFormTypeComboBoxComponent,
    PageComboBoxComponent,
    GroupingCodeComboBoxComponent,
    VMediumTypeComboBoxComponent,
    CwsPlanCategoryCodeComboBoxComponent,
    OrderNumQuotaCodeComboBoxComponent,
    MarkCodeTextInputComponent,
    IconCodeTextInputComponent,
    DnaInfoCheckBoxListComponent,
    ConvDivComboBoxComponent,
    PromotionCodeComboBoxComponent,
    CatalogProgressTextInputComponent,
    CommaFormatComponent,
    MarkCodeComponent,
    CodeTextInputComponent,
    DispContentsTextComponent,
    SupplyPriceStandardTextComponent,
    SellAreaCodeComboBoxComponent,
    AssortTempDivComboBoxComponent,
    FeatureCodeComboBoxComponent,
    TagComboBoxComponent,
    VersatileComboBoxComponent,
    ClassificationsListComponent,
    PlessTitleWindowSubDirective,
    PagerComponent,
    CustomPagerComponent,
    TextInputComponent,
    TextAreaComponent,
    ClipboardCopyIconComponent,
    GoodsEcCategoryCodeComboBoxComponent,
    KYMW68ConvDivComboBoxComponent,
    Kymw68FeatureCodeComboBoxComponent,
    Kymw68TagComboBoxComponent,
    PlanMediumTypeComboBoxComponent,
    KomaMediumTypeComboBoxComponent,
    PlessInputTextCoopDeliDirective,
    TextInputCoopDeliComponent,
    NotNullTextInputCoopDeliComponent,
  ],
  providers: [
    KYMW00Model,
    PlessDialogServiceSub,
    PlessDialogMultiMessageServiceSub,
    DnaInfoComboBoxService,
    GetCodeListService,
    GetReserveCodeListService,
    GetClassListService,
    GetLargeClassListService,
    GetMiddleClassListService,
    GetSmallClassListService,
    GetPromotionInfoListService,
    GetCoopListService,
    GetStudioMasterListService,
    GetPeriodSeqListService,
    GetOrderListService,
    GetMediumListService,
    GetVMediumListService,
    GetVMediumDutiesListService,
    GetPageListService,
    GetGroupingCodeListService,
    GetVMediumListService,
    GetCwsPlanCategoryListService,
    GetOrderNumQuotaListService,
    GetMarkListService,
    GetIconListService,
    GetConvDivListService,
    GetPromotionCodeListService,
    GetCatalogProgressListService,
    GetSellAreaCodeListService,
    GetClassificationsListService,
    CheckNgWordsService,
    GetMessagesService,
    GetMultiMessagesService,
    FileUploadService,
    FileDownloadMultiService,
    GetFeatureCodeListService,
    GetGoodsEcCategoryListService,
    KYMW68GetConvDivListService,
    KYMW68GetFeatureCodeListService,
    KYMW68GetTagListService,
    GetMediumListPlanGoodsFlagService,
    GetMediumListKomaFlagService,
    GetUserColumnWidthSettingsService,
    RegistUserColumnWidthSettingsService,
  ],
})

/** 管理するモジュール */
export class AppCommonsModule { }
